export class AppError{

    constructor( public originalError? : any ){}

}


// WEBPACK FOOTER //
// ./src/app/errors/app-error.ts